import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnCameraGroup } from '@lib/api/entities';
import { SnCameraGroupsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-add-camera-group-dialog',
  templateUrl: './add-camera-group-dialog.component.html',
  styleUrls: ['./add-camera-group-dialog.component.scss'],
})
export class AddCameraGroupDialogComponent implements OnInit, OnDestroy {
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        type: 'text',
      },
    },
  ];

  public formModel: any = {};
  public editOrAddDialogKey: string;

  private readonly _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnCameraGroup,
    private readonly _dialogRef: MatDialogRef<AddCameraGroupDialogComponent>,
    private readonly _cameraGroupsAPI: SnCameraGroupsAPI,
  ) {}

  public ngOnInit(): void {
    this.formModel.name = this.data?.name || '';
    this.editOrAddDialogKey = this.data?.name
      ? 'cameras.groupDialog.titleEdit'
      : 'common.addCameraGroup';
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submit(): void {
    this._cameraGroupsAPI
      .create(this.formModel)
      .pipe(takeUntil(this._destroy$))
      .subscribe((group) => {
        this._dialogRef.close(group);
      });
  }

  public close(): void {
    this._dialogRef.close();
  }
}
